export default [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "Home" */ "@/views/Home.vue"),
    meta: {
      title: "管理员查询",
    },
  },
  {
    path: "/account",
    name: "Account",
    component: () => import("@/views/Account.vue"),
    meta: {
      title: "单位账户管理员",
    },
  },
  {
    path: "/address",
    name: "Address",
    component: () => import("@/views/Address.vue"),
    meta: {
      title: "单位通讯录管理员",
    },
  },
  {
    path: "/business",
    name: "Business",
    component: () => import("@/views/Business.vue"),
    meta: {
      title: "业务应用管理员",
    },
  },
];
